import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import classNames from 'classnames';
import * as validators from '../../util/validators';
import {
  Form,
  PrimaryButton,
  FieldTextInput,
  NamedRedirect,
  CustomRadioButton,
} from '../../components';

import css from './ConfirmSignupForm.module.css';
import ProviderConfirmSignup from './ProviderConfirmSignup';
import { COMPANY_SIGN_UP, USER_TYPE, customIdsKeyName } from '../../marketplace-custom-config';
import { storedData } from '../../util/sessionStorageHelper';
import CustomerConfirmSignup from './CustomerConfirmSignup';

const KEY_CODE_ENTER = 13;

const signupTypeOptions = (businessSignupLabel, workerSignupLabel) => ({
  [customIdsKeyName.business]: {
    value: customIdsKeyName.business,
    label: businessSignupLabel,
  },
  [customIdsKeyName.worker]: { value: customIdsKeyName.worker, label: workerSignupLabel },
});

const ConfirmSignupFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={formRenderProps => {
      const {
        rootClassName,
        className,
        formId,
        inProgress,
        invalid,
        onOpenTermsOfService,
        authInfo,
        idp,
        values,
        form,
        userNativeLang,
        onManageDisableScrolling,
        errorMessage,
        history,
        intl,
        initialValuesForWorker,
      } = formRenderProps;
      const { signupUserType, ...restValues } = values;
      const [signupBtn, setSignUpBtn] = useState('worker');
      console.log(7777, signupBtn);
      const { userType } = authInfo || {};
      const sessionUserType = storedData(USER_TYPE);
      const isValidUserType = !!userType && !!sessionUserType && sessionUserType === userType;
      console.log('user', userType, sessionUserType);
      useEffect(() => {
        handleSignupTypeChange('worker');
      }, []);
      if (!isValidUserType && typeof window !== 'undefined') {
        return <NamedRedirect name="LoginPage" />;
      }
      const businessSignupLabel = intl.formatMessage({ id: 'TopbarDesktop.businessSignup' });
      const workerSignupLabel = intl.formatMessage({ id: 'TopbarDesktop.workerSignup' });

      const signupUserTypeOptions =
        userType !== customIdsKeyName.guest
          ? {}
          : signupTypeOptions(businessSignupLabel, workerSignupLabel);

      const handleSignupTypeChange = value => {
        console.log(3544, value);
        const entries = Object.entries(initialValuesForWorker || {});
        if (entries.length > 0) {
          form.batch(() => {
            for (let entry of entries) {
              form.change(entry[0], value === customIdsKeyName.worker ? entry[1] : undefined);
            }
          });
        }
        form.change('signupUserType', value);
      };

      return userType === customIdsKeyName.business ? (
        <ProviderConfirmSignup
          rootClassName={rootClassName}
          className={className}
          formId={formId}
          inProgress={inProgress}
          invalid={invalid}
          onOpenTermsOfService={onOpenTermsOfService}
          authInfo={authInfo}
          idp={idp}
          values={restValues}
          formApi={form}
          onSubmit={props.onSubmit}
          userNativeLang={userNativeLang}
          onManageDisableScrolling={onManageDisableScrolling}
          errorMessage={errorMessage}
          history={history}
        />
      ) : userType === customIdsKeyName.worker ? (
        <CustomerConfirmSignup
          rootClassName={rootClassName}
          className={className}
          formId={formId}
          inProgress={inProgress}
          invalid={invalid}
          onOpenTermsOfService={onOpenTermsOfService}
          authInfo={authInfo}
          idp={idp}
          values={restValues}
          formApi={form}
          onSubmit={props.onSubmit}
          userNativeLang={userNativeLang}
          onManageDisableScrolling={onManageDisableScrolling}
          signupErrorMessage={errorMessage}
          history={history}
        />
      ) : userType === customIdsKeyName.guest ? (
        <div>
          <div className={css.signupOptionWrapper}>
            <div className={css.signupOptionLabel}>
              <FormattedMessage id="ConfirmSignupForm.guestSignupLabel" />
            </div>
            {/* <div className={css.SignupRadiobtn}>
            <CustomRadioButton
            className={css.signup}
              name="signupUserType"
              radioValues={Object.values(signupUserTypeOptions)}
              id={formId ? `${formId}.signupType` : 'signupType'}
              withForm={false}
              formClassName={css.option1}
              values={values}
              onChange={handleSignupTypeChange}
            />
          </div> */}
            <div className={css.tabContainer}>
              <span className={css.tabDiv}>
                <button
                  type="button"
                  className={classNames(css.desktopReviewsTabNav, {
                    // [css.selectedTab]: search?.tab === 'BestMatches',
                    [css.selectedTab]: signupBtn === 'worker',
                  })}
                  onClick={() => {
                    handleSignupTypeChange('worker');
                    setSignUpBtn('worker');
                  }}
                >
                  <span className={css.tabText}>
                    {/* <FormattedMessage id="SearchPage.BestMatches" /> */}
                    Signup As Worker
                  </span>
                </button>
                <button
                  type="button"
                  className={classNames(css.desktopReviewsTabNav, {
                    // [css.selectedTab]: search?.tab === 'MostRecent',
                    [css.selectedTab]: signupBtn === 'business',
                  })}
                  onClick={() => {
                    handleSignupTypeChange('business');
                    setSignUpBtn('business');
                  }}
                >
                  <span className={css.tabText}>Signup As Company</span>
                </button>
              </span>
            </div>
          </div>
          <div>
            {signupUserType === signupUserTypeOptions[customIdsKeyName.business].value ? (
              <ProviderConfirmSignup
                rootClassName={rootClassName}
                className={className}
                formId={formId}
                inProgress={inProgress}
                invalid={invalid}
                onOpenTermsOfService={onOpenTermsOfService}
                authInfo={authInfo}
                idp={idp}
                values={restValues}
                formApi={form}
                onSubmit={props.onSubmit}
                userNativeLang={userNativeLang}
                onManageDisableScrolling={onManageDisableScrolling}
                errorMessage={errorMessage}
                history={history}
              />
            ) : signupUserType === signupUserTypeOptions[customIdsKeyName.worker].value ? (
              <CustomerConfirmSignup
                rootClassName={rootClassName}
                className={className}
                formId={formId}
                inProgress={inProgress}
                invalid={invalid}
                onOpenTermsOfService={onOpenTermsOfService}
                authInfo={authInfo}
                idp={idp}
                values={restValues}
                formApi={form}
                onSubmit={props.onSubmit}
                userNativeLang={userNativeLang}
                onManageDisableScrolling={onManageDisableScrolling}
                signupErrorMessage={errorMessage}
                history={history}
              />
            ) : null}
          </div>
        </div>
      ) : null;
    }}
  />
);

ConfirmSignupFormComponent.defaultProps = { inProgress: false };

const { bool, func } = PropTypes;

ConfirmSignupFormComponent.propTypes = {
  inProgress: bool,

  onOpenTermsOfService: func.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const ConfirmSignupForm = compose(injectIntl)(ConfirmSignupFormComponent);
ConfirmSignupForm.displayName = 'ConfirmSignupForm';

export default ConfirmSignupForm;
